import { render, staticRenderFns } from "./BaseVideo.vue?vue&type=template&id=0ddf0405"
import script from "./BaseVideo.vue?vue&type=script&lang=js"
export * from "./BaseVideo.vue?vue&type=script&lang=js"
import style0 from "./BaseVideo.vue?vue&type=style&index=0&id=0ddf0405&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports